export default __webpack_public_path__ + "images/Chak-French-couple-riding-a-vespa-scooter-along-the-seaside.webp";